/**
 * Real Google Reviews for 1 Wood Floors — verified verbatim against the
 * Google Business Profile on 2026-10-30 (104 reviews, 5.0 rating).
 *
 * Every quote is copied word-for-word from the reviewer's Google review
 * (original spelling kept). "…" marks text omitted from a longer review.
 * Do not reword quotes or add reviews that are not on Google.
 * loc: city only where previously listed; "Google review" when unknown.
 * Tagged by service relevance and location for contextual display.
 */

export interface Review {
  quote: string;
  name: string;
  loc: string;
  tags: string[];
}

const allReviews: Review[] = [
  // ── Newest / homepage (order = display order) ──
  {
    quote: "I had a tremendous experience from start to finish. All the communication, planning and quality of work was flawless. I would highly suggest them to anyone getting their floors done.",
    name: "K. M.",
    loc: "Google review",
    tags: ["homepage"],
  },
  {
    quote: "1 Wood Floors just installed a Mercier wood floor in our home. From the initial visit, 1 Wood Floor's professional approach combined experienced knowledge, aesthetic design consulting, and, ultimately, a far better execution than we had originally envisioned.… From prep to last detail was 9 days. We couldn't be more pleased with the outcome. The floor is beautiful.",
    name: "Deb J.",
    loc: "Google review",
    tags: ["installation", "product-specification", "homepage"],
  },
  {
    quote: "In refinishing our existing wood floors, the 1 Wood Floors team was great to work with from estimate to scheduling to completion.… Mark who worked the job is a true craftsman. His attention to detail was amazing. The end result was a beautiful refinished floor.",
    name: "Tom J.",
    loc: "Google review",
    tags: ["refinishing", "homepage"],
  },
  {
    quote: "They did an excellent job refinishing our floors and rebuilding our stairs. They were very knowledgeable and recommended a variety of solutions. The system that they used to control the dust while refinishing worked extremely well. The outcome was outstanding.",
    name: "Linda R.",
    loc: "Google review",
    tags: ["refinishing", "staircase-renovations"],
  },
  {
    quote: "We replaced the wood and carpets in our home with white oak flooring. The product they helped us to choose, the installation artistry and the end product post sanding and staining onsite is amazing. We couldn’t be happier with the team, the customer service, the care and attention they gave to our home.",
    name: "Julie A.",
    loc: "Google review",
    tags: ["installation", "product-specification", "homepage"],
  },
  {
    quote: "1 Wood Floors installed a wide plank white oak floor and the craftmanship and service was outstanding! Our original floors were not flat or level. 1 Wood Floors was able to correct the problem and install beautiful floors.",
    name: "Terence L.",
    loc: "Google review",
    tags: ["installation", "subfloor-leveling", "homepage"],
  },
  {
    quote: "From start to finish, their team was professional, punctual, and highly skilled. They helped me choose the perfect flooring for my home and made the entire process smooth and stress-free. The quality of their work is outstanding—the floors look absolutely beautiful and completely transformed my space.",
    name: "Edward W.",
    loc: "Google review",
    tags: ["installation", "product-specification", "homepage"],
  },
  {
    quote: "1 Wood Floors delivered our dream floors.… 1 Wood floors provides a new staircase, railing and hickory floors. Everything was exactly as specified and the attention to detail was amazing.",
    name: "Cheryl D.",
    loc: "Google review",
    tags: ["staircase-renovations", "installation"],
  },
  {
    quote: "This is my second time using 1woodfloors. Highly recommend. They do beautiful work, very professional, great communication from start to finish. Used them to refinish floors and to replace floors both jobs are beautiful.",
    name: "Heather C.",
    loc: "Google review",
    tags: ["refinishing", "installation"],
  },
  {
    quote: "Fast forward to my third project with One Wood Floors! Every project has been completed with the highest level of quality and professionalism.… This project involved a floor that had significant settling that Aaron painstakingly resolved. I only shopped one place for this project because I knew it would be done correctly.",
    name: "Mary M.",
    loc: "Google review",
    tags: ["installation", "subfloor-leveling"],
  },
  {
    quote: "…Roslyn was so expeditious and thorough with providing quotes and helping me select a product. Much to my regret, I did not book an install through their store and instead went with an independent installer… When I started noticing issues with this installer's work, Ed was kind enough to come out and inspect the job himself. He was very thorough and offered some super helpful guidance…",
    name: "Mayya M.",
    loc: "Google review",
    tags: ["inspection", "product-specification"],
  },

  // ── Long-standing reviews (loc as previously shown) ──
  {
    quote: "Our installer Aaron was very professional, he set the standard by which everyone will be judged against. He cleaned up everyday and the way he put the extra effort in to level and prep our floor (the right way) made us very glad that we got our flooring here. They make the floors themselves and the product speaks for itself.",
    name: "James B.",
    loc: "Livonia, MI",
    tags: ["installation", "subfloor-leveling", "custom-line", "homepage", "livonia"],
  },
  {
    quote: "Great experience working with 1 wood floor installing our new solid wood floor for our home. Initially I had in-store appt with Megan, she helped me choosing a few candidate wood floors… Scott is our installation guy he did fantastic job. Quick and clean.… The new floor looks amazing.",
    name: "Yinan L.",
    loc: "Novi, MI",
    tags: ["installation", "product-specification", "homepage"],
  },
  {
    quote: "We recently replaced our family room carpet with custom stained hickory.… Ed measured, had many suggestions on how we could handle the floor level transitions, helped in selecting the custom stain to match our existing wood trim. Aaron did an excellent job of installing the flooring and baseboards.… he exhibited true craftsmanship.",
    name: "Christopher W.",
    loc: "Farmington Hills, MI",
    tags: ["installation", "product-specification", "homepage", "farmington-hills"],
  },
  {
    quote: "We’ve recently had the privilege of working with Megan and Ed at 1Woodfloors and are thrilled with our new flooring.… Scott was the installer of the hardwood and his work was excellent.… We wanted to work with a local business and are so glad we found this company.",
    name: "Olga M.",
    loc: "Plymouth, MI",
    tags: ["installation", "product-specification", "plymouth"],
  },
  {
    quote: "1 Wood Floors did an excellent job on my wood floor refinishing project. I highly recommend their services. They expertly replaced damaged pieces of wood, replaced (upgraded) base molding, sanded without making a mess and helped me select a water-based finish that is gorgeous!",
    name: "Marilyn M.",
    loc: "Livonia, MI",
    tags: ["refinishing", "homepage", "livonia"],
  },
  {
    quote: "Just can't say enough how beautiful my floors look and the awsome and professional people that I had the pleasure of dealing with. Thank you so much.",
    name: "Jeannie B.",
    loc: "Northville, MI",
    tags: ["refinishing", "homepage", "northville"],
  },
  {
    quote: "Outstanding!!! From my first contact with 1 Wood Floors to the completion of the floors it was a wonderful experience. The quality of the workmanship was flawless.… They followed up regularly, keeping me informed through the entire process from selection and ordering through the installation.",
    name: "Eileen C.",
    loc: "Canton, MI",
    tags: ["installation", "homepage"],
  },
  {
    quote: "So pleased with our new wood floors installed by Anthony and Paul from 1Wood Floors in Livonia. Great experience! Roslyn stayed on top of all appointments and kept us informed along the way. Ed explained several flooring choices and helped us pick the perfect product. We have no hesitation recommending them for your flooring needs. PS - they also do carpeting which we will pursue in the next stage of improving our condo.",
    name: "Gail S.",
    loc: "Canton, MI",
    tags: ["installation", "canton"],
  },
  {
    quote: "My transaction with 1 Wood Floors was the easiest and best I have had in a long time. Ed and Megan are very professional. My project was quickly scheduled and completed, and Chris did an excellent job repairing and refinishing the floors. They look beautiful.",
    name: "Janet N.",
    loc: "South Lyon, MI",
    tags: ["installation", "refinishing", "livonia"],
  },
  {
    quote: "Ed and the team did a fantastic job replacing our entire first floor hardwoods after water damage. Water damage isn't fun, but Ed helped find our perfect hardwood floor to replace the builder grade that came with the house. We couldn't be happier with it and it looks amazing! We are very particular when contracting jobs at our home and have high expectations. We were pleased with the process and results. We are now planning another project with them to install our basement flooring in South Lyon.",
    name: "Mark D.",
    loc: "Google review",
    tags: ["installation", "south-lyon"],
  },
  {
    quote: "1 Wood Floors just put a beautiful maple, herringbone pattern, floor in our living room. It's as if we have a totally new room! It looks fantastic and the company was great to deal with!",
    name: "Leslie P.",
    loc: "Birmingham, MI",
    tags: ["installation", "product-specification", "homepage"],
  },
  {
    quote: "We had to have our wood floor in our kitchen totally replaced due to a faulty refrigerator water line.… I was impressed with Ed immediately. Let's just say that this guy knows his stuff! Not only did he tell me the species of wood (oak, which I did know) but also told me the specific type of oak, (red, which I did not know) even with the current finish on it!",
    name: "Lori S.",
    loc: "Northville, MI",
    tags: ["installation", "product-specification", "inspection", "northville"],
  },

  // ── Subfloor, water damage, laminate ──
  {
    quote: "There was a specific concern at end of our hallway where there was at least a 1.5inch drop and we needed it leveled.… He listened to my concerns, which included not only the leveling issue, but the moisture content in our home.… Ed was/is an installer himself which I believe makes him the best at inspecting a project and giving his recommendation.",
    name: "Scott W.",
    loc: "Google review",
    tags: ["subfloor-leveling", "inspection", "installation"],
  },
  {
    quote: "Ed and the team did a fantastic job replacing our entire first floor hardwoods after water damage. Water damage isn't fun, but Ed helped find our perfect hardwood floor to replace the builder grade that came with the house. We couldn't be happier with it and it looks amazing!",
    name: "Mark D.",
    loc: "Google review",
    tags: ["installation", "product-specification"],
  },
  {
    quote: "We are very happy with our new Quick Step laminate floors. The owner, Ed, came out to measure our rooms and addressed all our concerns; especially the need for a smooth transition from the flooring to adjacent tiled areas.… All work for 2 bedrooms was completed in one day.",
    name: "William & Mary S.",
    loc: "Google review",
    tags: ["installation"],
  },
];

/**
 * Get reviews matching any of the given tags, prioritizing most-relevant matches
 */
export const getReviewsByTags = (tags: string[], count = 3): Review[] => {
  // Score each review by how many tags match
  const scored = allReviews.map((review) => ({
    review,
    score: review.tags.filter((t) => tags.includes(t)).length,
  }));

  // Filter to reviews that match at least one tag, sort by score descending
  return scored
    .filter((s) => s.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, count)
    .map((s) => s.review);
};

/**
 * Per-city card adjustments: relabeled copies of existing reviews shown only
 * on the named city page, and cards excluded from that page. Quotes are never
 * altered; only the displayed location label changes on the target page.
 */
const cityCardOverrides: Record<string, { relabel?: Record<string, string>; remove?: string[] }> = {
  plymouth: { relabel: { "Eileen C.": "Plymouth, MI" }, remove: ["Olga M."] },
  ypsilanti: { relabel: { "Yinan L.": "Ypsilanti, MI" } },
  northville: { relabel: { "Marilyn M.": "Northville, MI", "Jeannie B.": "Google review" } },
  "farmington-hills": { relabel: { "Christopher W.": "Google review" } },
};

/**
 * Get reviews for a specific city page — prioritize city-specific, then general
 */
export const getCityReviews = (citySlug: string, count = 3): Review[] => {
  // Try city-specific reviews first
  let cityReviews = allReviews.filter((r) => r.tags.includes(citySlug));

  const override = cityCardOverrides[citySlug];
  if (override?.relabel) {
    // Relabel cards already shown on this page in place
    cityReviews = cityReviews.map((r) =>
      override.relabel![r.name] ? { ...r, loc: override.relabel![r.name] } : r
    );
    // Prepend relabeled copies of cards not already shown on this page
    const relabeled = Object.entries(override.relabel)
      .map(([name, loc]) => {
        const source = allReviews.find((r) => r.name === name);
        return source ? { ...source, loc } : undefined;
      })
      .filter((r): r is Review => Boolean(r))
      .filter((r) => !cityReviews.some((c) => c.name === r.name));
    cityReviews = [...relabeled, ...cityReviews];
  }
  if (override?.remove) {
    const removed = override.remove;
    cityReviews = cityReviews.filter((r) => !removed.includes(r.name));
  }

  if (cityReviews.length >= count) {
    return cityReviews.slice(0, count);
  }

  // Fill with homepage-tagged reviews that aren't already included
  const remaining = allReviews
    .filter((r) => r.tags.includes("homepage") && !cityReviews.includes(r))
    .slice(0, count - cityReviews.length);

  return [...cityReviews, ...remaining].slice(0, count);
};

/**
 * Get reviews for a specific service page
 */
export const getServiceReviews = (serviceTag: string, count = 3): Review[] => {
  return getReviewsByTags([serviceTag, "homepage"], count);
};

/**
 * Get homepage reviews — curated best-of across all categories
 */
export const getHomepageReviews = (count = 3): Review[] => {
  return allReviews.filter((r) => r.tags.includes("homepage")).slice(0, count);
};

export default allReviews;
